import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GameService {

  constructor(
    private http: HttpClient,
  ) { }

  getCasualGames(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/api/v1/game/list', {withCredentials: true});
  }

  endCasualGame(game_uuid): Observable<any> {
    return this.http
    .patch<any>(environment.apiUrl + `/api/v1/game/${game_uuid}/cancel`, '',{ withCredentials: true });
  }

  endLeagueGame(item, game_uuid): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `/api/v1/game/${game_uuid}/update`, JSON.stringify(item),{ withCredentials: true });
  }
}
